import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinWatchersIssueRoute: InvariantJiraRoute = {
	name: 'legacy-gin-watchers-issue',
	path: '/secure/ManageWatchers!default.jspa',
};
